module.exports = __webpack_public_path__ + "files/84967a0d47df515baa551d66dcd386d6.png";